import { Logger, LoggerService } from "@Shared/logger";
import { BlueConicOptions } from "./_models";
import { BlueConicLowaService, BlueConicReadinessService } from "./services";

export class BlueConicModuleClass {
  private Logger: Logger = LoggerService.createLogger("BlueConicModule");

  constructor() {
    this.Logger.trace("****  CTOR ****");
  }

  public async init( options: BlueConicOptions ): Promise<void> {
    this.Logger.trace("BlueConic Module Initializing", options);
    BlueConicReadinessService.Instance;
    BlueConicLowaService.Instance;
    return Promise.resolve();
  }
}

export const BlueConicModule = new BlueConicModuleClass();
